<template>
  <BaseAutoComplete
    v-model="model"
    :options="materials"
    v-bind="$attrs"
  />
</template>

<script lang="ts" setup>
import { find } from 'underscore'
import { computed, watch } from 'vue'
// import MaterialForm from '@/modules/Catalog/Material/components/MaterialForm.vue'
import MaterialService from '@/services/MaterialService'
import { useQuery } from '@tanstack/vue-query'
import BaseAutoComplete from './BaseAutoComplete.vue'

const selectedMaterial = defineModel({
  type: String,
  default: ''
})

// const material = ref({
//   name: '',
//   description: '',
//   cost: '',
//   image: ''
// })

const emit = defineEmits(['change'])

const materialService = new MaterialService()
const { data: materials } = useQuery({
  queryKey: ['materials'],
  queryFn: () => materialService.all().then((materials) => materials.map((material) => ({ label: material.name, value: material.id, ...material })))
})

const model = computed({
  get: () => {
    if (materials.value) {
      return find(materials.value, (material) => material.value === selectedMaterial.value)
    }
    return null
  },
  set: (value) => {
    selectedMaterial.value = value.value
  }
})

watch(model, () => {
  if (model.value) {
    selectedMaterial.value = model.value.value
  }
  emit('change', model.value)
})

// const fileUploadCompleted = (url) => {
//   material.value.image = url
// }

// const saveMaterial = async () => {
//   // const material = await this.createMaterial(this.material)
//   // set selected material

//   // close modal

//   // reset material data
//   material.value = {
//     name: '',
//     description: '',
//     cost: '',
//     image: ''
//   }
// }
</script>
